import { useMemo, FC } from 'react';
import { Column, CellProps } from 'react-table';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { IBrandsCataloguesPage } from 'stores/brands/types';
import { Table } from 'components/Core/Table';
import { AvatarIcon } from 'components/Core/AvatarIcon/AvatarIcon';
import { NoDataComponent } from 'components/Core/NoData/NoData';
import { ReactComponent as EditIcon } from 'assets/edit_icon.svg';
import { cataloguesPagesTableTranslations } from './translations';
import { CataloguesPagesTableTransFields } from './types';
import styles from './cataloguesPagesTable.module.scss';
import { updateImageUrl } from 'utils/convertString';

const AVATAR_SIZE = 56;

export const CataloguesPagesTable: FC = observer(() => {
  const {
    brandsStore: { brandsCatalogue },
  } = useStore();

  const { i18n, t } = useMyTranslations<CataloguesPagesTableTransFields>([cataloguesPagesTableTranslations.name]);

  const columns: Column<IBrandsCataloguesPage>[] = useMemo(
    () => [
      {
        Header: t('page'),
        id: 'page',
        Cell: ({ row: { original } }: CellProps<IBrandsCataloguesPage>) => (
          <div className={styles.avatar}>
            <AvatarIcon
              avatar={updateImageUrl(original.imageUrl, AVATAR_SIZE * 2)}
              name='point image'
              size={AVATAR_SIZE}
              styleProps={{ borderRadius: 8 }}
            />
            <p className={styles.name}>
              {t('page')} {original.position}
            </p>
          </div>
        ),
        accessor: (row) => row.position,
        width: 9,
      },
      {
        Header: t('products'),
        id: 'products',
        accessor: (row) => row.products.length,
        width: 6,
      },
      {
        Header: t('option'),
        id: 'option',
        Cell: ({
          row: {
            original: { position },
          },
        }: CellProps<IBrandsCataloguesPage>) => (
          <div className={styles.actionBoxBtn}>
            <Link to={`pages/${position}`} className={styles.editBtn}>
              <EditIcon />
            </Link>
          </div>
        ),
        width: 2,
        disableSortBy: true,
      },
    ],
    // eslint-disable-next-line
    [brandsCatalogue, i18n.language]
  );

  columns.forEach((item) => (item.Filter = () => null));

  return (
    <>
      {brandsCatalogue && brandsCatalogue.pages.length > 0 ? (
        <Table columns={columns as never} data={[...brandsCatalogue.pages]} isFullHeight />
      ) : (
        <NoDataComponent />
      )}
    </>
  );
});
